import { actionUserLogin, actionUserLogout, loginTma } from '@shared-core/features/auth'
import { handleErrors } from '@shared-core/features/notifications'
import { API_KNOWN_ERRORS } from '@shared-core/services/api'
import type { AppDispatch } from '@shared-core/store'
import { getTelegramWebApp, isTMA } from '@web/libs/tg/platform'

export async function bootstrapTmaSession(dispatch: AppDispatch): Promise<void> {
  if (!isTMA()) return

  // Сохранённая сессия могла принадлежать другому аккаунту Telegram.
  dispatch(actionUserLogout())

  try {
    await dispatch(loginTma({ initData: getTelegramWebApp()?.initData ?? '' })).unwrap()
    dispatch(actionUserLogin())
  } catch {
    dispatch(handleErrors(null, { defaultError: { error: API_KNOWN_ERRORS.REQUEST_ERROR } }))
  }
}
